import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupCashOpeningBalances } from "src/components/Shared/NewForms/NFLookupCashOpeningBalances";
import { NFLookupCashRegister } from "src/components/Shared/NewForms/NFLookupCashRegister";
import { NFPlainNumber } from "src/components/Shared/NewForms/NFPlainNumber";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";

export const CashOpeningBalancesDetailLines = () => {
  const tableName = "products";
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();
  useEffect(() => {}, []);

  return (
    <>
      <NFormTable fieldArray={"lines"}>
        <NFPlainNumber fieldName={"lineNo"} title={t("#")} width={50} />
        <NFLookupCashOpeningBalances fieldName={"cashOpeningBalanceId"} title={t("CashOpeningBalance")} width={200} />
        <NFLookupCashRegister title={t("CashRegister")} fieldName="cashRegisterId" />
        <NFIntInput fieldName={"amount"} title={t("Amount")} />
        <NFIntInput fieldName={"currencyAmount"} title={t("CurrencyAmount")} />
      </NFormTable>
    </>
  );
};
